export default __webpack_public_path__ + "static/search-nodata-318a92f209c002465a7e937076f7d481.svg";